import ClientService from '@boServices/clientService';
import { useCallback, useEffect, useRef, useState } from 'react';

const clientService = new ClientService();

// `enabled: false` skips fetching, e.g. while the list is not displayed.
const useClients = ({ search, status, category, page, perPage, enabled = true }) => {
    const [clients, setClients] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const abortRef = useRef(null);

    const fetchClients = useCallback(async () => {
        // A newer request cancels the previous one, whose late result must not overwrite the current list.
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;

        setLoading(true);
        try {
            const data = await clientService.getClients({ search, status, category, page, perPage, signal: controller.signal });
            if (controller.signal.aborted) return;
            setClients(data.items ?? []);
            setTotal(data.total ?? 0);
            setError(null);
        } catch (err) {
            if (!controller.signal.aborted) setError(err);
        } finally {
            if (!controller.signal.aborted) setLoading(false);
        }
    }, [search, status, category, page, perPage]);

    useEffect(() => {
        if (!enabled) return undefined;
        fetchClients();
        return () => abortRef.current?.abort();
    }, [fetchClients, enabled]);

    return { clients, total, loading, error, refresh: fetchClients };
};

export default useClients;
